<template> 
  <div class="leftside-menu" >    
      <!-- LOGO -->
      <a href="/" class="logo text-center logo-light">
          <span class="logo-lg">
              <img src="/assets/images/logo.png" alt="Logo" class="img-fluid logo-img">
          </span>
          <span class="logo-sm">
              <img src="/assets/images/logo_sm.png" alt="Logo Sm" class="img-fluid logo-img-sm">
          </span>
      </a>

      <div class="h-100 scrollbar-width-thin sidebar-scroll-container" id="leftside-menu-container" data-simplebar> 
          <!--- Sidemenu --> 
          <ul class="side-nav">  
              <li class="side-nav-item" :class="{ 'has-children': route.children && route.children.length > 0 }" v-for="route in routes" :key="route.name">
                
                  <a data-bs-toggle="collapse" :href="'#' + route.name" aria-expanded="false" class="side-nav-link d-flex align-items-center justify-content-between" v-if="route.children && route.children.length > 0" @click="checkParrentNav(route.name)">
                      <div class="d-flex align-items-center">
                          <i v-if="route.icon_name" :class="route.icon_name + ' nav-icon'"></i> 
                          <span class="nav-text">{{route.name}}</span>
                      </div>
                      <span class="menu-arrow"><i class="fas fa-chevron-right"></i></span>
                  </a>
                  
                  <router-link :to="route.path" class="side-nav-link d-flex align-items-center" v-else @click.prevent="$router.push(route.path)">
                      <i v-if="route.icon_name" :class="route.icon_name + ' nav-icon'"></i>
                      <span class="nav-text">{{route.name}}</span>
                  </router-link> 

                  <div class="collapse" :id="route.name" v-if="route.children && route.children.length > 0">
                      <ul class="side-nav-second-level">
                          <li v-for="children in route.children" :key="children.name">
                            <router-link :to="children.path" class="side-nav-sub-link d-flex align-items-center">
                              <span class="nav-sub-text">{{children.name}}</span>
                            </router-link> 
                          </li> 
                      </ul>
                  </div>                  
                  
              </li>  
          </ul> 

          <div class="clearfix"></div>

      </div>
  </div>   
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';
import { useProductStore } from '@/stores/product';
import { useRequisitionProductStore } from '@/stores/requisitionProduct';

// 
// import { defineComponent } from 'vue'
// import { FadeInOut } from 'vue3-transitions'
// import About from "@/views/page/RolePermission.vue";  
export default {
  name: 'NavigationTemplate',
  props: {
    msg: String
  },
  // components: { FadeInOut },
  data() {
    return {
      routes: [],
      activeClass:''
    };

  },
  methods:{  
    checkParrentNav(name){
      // console.log('checkParrentNav', name)
      // console.log('UserMenuAndPermissions', this.$store.getters.userAllPermissions[name][0].children)
    }
  },
  computed: {
    computedClass() {
      if(this.currentRouteName =='/pos'){
        return 'active';
      }else{
        return '';
      }  
    },
    currentRouteName() {
        return this.$route.path;
    }
  },
  mounted() { 
     
  },
  created(){   
    //this.$router.removeRoute('Outlet')
    //console.log(this.$router.options.navigations);
    this.routes = this.$router.options.navigations
  }
}

</script>
 
<style>
  .logo {
    line-heght: 1.5 !important;
  }
</style>